import { Link } from "react-router-dom";

import { ScreenThumbnail } from "./assets";

import { Location } from "@cobliteam/common-types";

import { Analytics } from "@cobliteam/analytics";
import { AlertsTour } from "@cobliteam/onboarding";

import { TripsIcon } from "@cobliteam/base-components/src/icons";

import { Button, Typography } from "@cobliteam/ui/components";

import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import SignalCellularAltRoundedIcon from "@mui/icons-material/SignalCellularAltRounded";

export const AlertSettingsCTA = () => {
  const steps = [
    {
      Icon: NotificationsRoundedIcon,
      iconColor: "text-warning",
      content: (
        <>
          1. Controle os alertas e <b>ative apenas as regras mais valiosas</b>{" "}
          para você e sua frota.
        </>
      ),
    },
    {
      Icon: TripsIcon,
      iconColor: "text-primary-dark",
      content: (
        <>
          2. Veja os alertas mais importantes e confira mais detalhes sobre o
          trajeto direto no mapa.
        </>
      ),
    },
    {
      Icon: SignalCellularAltRoundedIcon,
      iconColor: "text-success",
      content: (
        <>
          3. <b>Veja os alertas mais graves</b> e converse com os motoristas
          sobre responsabilidade no trânsito.
        </>
      ),
    },
  ];

  return (
    <div className="relative">
      <div className="rounded-b-2xl bg-primary-dark p-5">
        <div className="w-5/12 space-y-2.5">
          <Typography variant="display" className="text-white">
            Configure regras para seus alertas
          </Typography>
          <Typography variant="description-list-default" className="text-white">
            Os alertas enviados ficarão salvos no histórico para serem
            consultados. Assim fica mais fácil acionar os responsáveis e
            melhorar o desempenho da sua frota.
          </Typography>
        </div>
      </div>

      <div className="flex w-5/12 flex-col items-center gap-5">
        <div className="flex flex-col gap-7 p-5">
          {steps.map(({ Icon, iconColor, content }) => (
            <div key={Math.random()} className="flex items-center gap-2.5">
              <Icon
                className={`box-content h-7 w-7 shrink-0 rounded bg-gray-lightest p-2.5 ${iconColor}`}
              />
              <Typography variant="description-list-default">
                {content}
              </Typography>
            </div>
          ))}
        </div>

        <Button color="success" asChild>
          <Link
            to={{
              pathname: Location.CONFIG,
              search: "page=alerts",
            }}
            onClick={() =>
              Analytics.track("Clicked To Setup User Alert Settings From CTA")
            }
          >
            Configurar alertas
          </Link>
        </Button>
      </div>

      <img
        src={ScreenThumbnail}
        alt="Screen thumbnail"
        className="relative w-7/12 p-5 md:visible md:absolute md:right-0 md:top-0"
      />

      <AlertsTour />
    </div>
  );
};

export default AlertSettingsCTA;
